import styled from "styled-components";

import { TicketStyledProps as Props } from "./Ticket.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const TicketStyled = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--palette-mid-blue-s13-l18);
  padding: 1.2rem;
  border-radius: 0.8rem;
  border-left: 0.4rem solid var(--palette-primary);
  margin-bottom: 1.6rem;

  .Ticket {
    &__mobile {
      display: none;

      @media (max-width: ${tablet - 1}px) {
        display: flex;

        &__type {
          background-color: var(--palette-dark-blue-s13-l11);
          padding: ${props => (props.label ? "0.8rem 0.4rem" : "0.6rem")};
          color: var(--palette-primary);
          font-weight: 700;
          font-size: 1.6rem;
          border-radius: 0.8rem;
          border: solid 0.2rem var(--palette-gray-s0-l20);
          width: ${props => (props.label ? "8rem" : "5.6rem")};
          text-overflow: ellipsis;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          width: 4.8rem;
        }
      }
    }

    &__content-right {
      display: flex;
      align-items: center;
      width: 72%;
    }

    &__quantity {
      background-color: var(--palette-dark-blue-s13-l11);
      padding: ${props => (props.label ? "0.8rem 0.4rem" : "0.6rem")};
      color: var(--palette-primary);
      font-weight: 700;
      font-size: 2rem;
      border-radius: 0.8rem;
      border: solid 0.2rem var(--palette-gray-s0-l30-a40);
      width: ${props => (props.label ? "8rem" : "5.6rem")};
      text-overflow: ellipsis;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;

      @media (max-width: ${tablet - 1}px) {
        width: 5.6rem;
      }
    }

    &__label {
      font-weight: 600;
      font-size: 1.8rem;
      padding: 0 1.2rem;
      color: var(--palette-white);
      width: 100%;
      text-overflow: ellipsis;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-align: start;
    }

    &__content-left {
      display: flex;
      align-items: center;
    }

    &__price {
      padding-right: 0;
      color: var(--palette-gray-s0-l80);
      font-size: 1.4rem;
      font-weight: 400;
    }
  }
`;

export default TicketStyled;
